import Loadable from '../../../components/loadable';

const ConfirmRemoveStyle = Loadable({
  loader: () => import('../../../pages/contacts/styles/confirm_remove_style'),
  type: 'modal',
});

angular.module('gym').value('ConfirmRemoveStyle', ConfirmRemoveStyle);
